// Canonical standard customer disclaimer.
//
// This MUST stay byte-identical to all of:
//   1. merchant-svc GeneralSetting.customerDisclaimer @default — apps/merchant-svc/prisma/schema.prisma
//   2. the concierge i18n key — apps/concierge/src/lang/en-US.json (consumed by CollectSignatureModal)
//   3. this constant
//
// Concierge translates the disclaimer "by key": when a store's stored disclaimer
// equals this string, it resolves to a translation; genuinely custom text has no
// key and is shown verbatim. Editing this string in isolation silently breaks that
// translation match, so update all three copies together.
//
// NOTE: the string contains a known typo ("your your original order"). It is
// intentionally preserved for byte-identity with the DB default and the i18n key —
// fixing it means updating all three at once (and existing stores still holding the
// old text would show the "Custom text" badge until reset).
export const STANDARD_CUSTOMER_DISCLAIMER =
  "By signing, you're acknowledging all information in your claim is truthful to the best of your knowledge. We will be unable to process a return for the items in your your original order for which a resolution has been sent. This information may be submitted to postal authorities. Any fraudulent information will be taken as mail fraud and prosecuted to the fullest extent of the law. In the event that your claim is investigated and reveals any fraudulent activity, you may be denied the right to return your product(s) for a refund or reshipment.";

// True when the stored disclaimer is the standard text (or empty) — i.e. Concierge
// will translate it. False when the merchant has entered custom text shown verbatim.
export const isStandardDisclaimer = (value: string | null | undefined): boolean => {
  const trimmed = (value ?? '').trim();

  return trimmed === '' || trimmed === STANDARD_CUSTOMER_DISCLAIMER.trim();
};
